export function isMobileDevice() {
  return (
    typeof navigator === 'object' &&
    /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test(
      navigator.userAgent,
    )
  );
}
